KlaviyoSubscribe.attachToForms(
  "#blog-siderbar-newletter,#footer-signup-newsletter",
  {
    hide_form_on_success: true,
    success_message:
      "Success! Please check your email for a confirmation message.",
    extra_properties: {
      $source: "Recipes Newsletter",
      $method_type: "$embed",
      $method_id: "embed",
    },
    success: function ($form, data) {
      //           console.log(data)
      var email = $form.find('[name="email"]').val();
      var is_subscribed = data.is_subscribed;
      try {
        gtag("event", "sign_up", {
          userId: "",
          uemh: SHA256(email),
          method: "Footer Newsletter",
        });
      } catch (er) {
        console.log(er);
      }
      if (is_subscribed) {
        $form
          .siblings(".klaviyo_messages")
          .find(".success_message")
          .text("")
          .hide();
        $form
          .siblings(".klaviyo_messages")
          .find(".error_message")
          .text(
            `${email} is already subscribed to list Popcorn Shed Website Customer List.`
          )
          .show();
      } else {
        $form
          .siblings(".klaviyo_messages")
          .find(".error_message")
          .text("")
          .hide();
      }
      //           try{
      //             _learnq.push(['identify', { $email: email }]);
      //             _learnq.push(['track', 'Signed Up for Newsletter']);
      //           }
      //           catch(er){
      //             console.log(er)
      //           }
    },
  }
);

if (document.querySelector("#mc-embedded-subscribe-form-page")) {
  console.log("form embedded");
  KlaviyoSubscribe.attachToForms("#mc-embedded-subscribe-form-page", {
    hide_form_on_success: true,
    success_message:
      "Success! Please check your email for a confirmation message.",
    extra_properties: {
      $source: "$embed",
      $method_type: "Newsletter landing page",
      $method_id: "embed",
    },
    success: function ($form, data) {
      //           console.log(data)
      var email = $form.find('[name="email"]').val();
      var is_subscribed = data.is_subscribed;
      try {
        gtag("event", "sign_up", {
          userId: "",
          uemh: SHA256(email),
          method: "Newsletter Landing Page",
        });
      } catch (er) {
        console.log(er);
      }
      if (is_subscribed) {
        $form
          .siblings(".klaviyo_messages")
          .find(".success_message")
          .text("")
          .hide();
        $form
          .siblings(".klaviyo_messages")
          .find(".error_message")
          .text(
            `${email} is already subscribed to list Popcorn Shed Website Customer List.`
          )
          .show();
      } else {
        $form
          .siblings(".klaviyo_messages")
          .find(".error_message")
          .text("")
          .hide();
      }
    },
  });
}
